var React = require('react');

var createReactClass = require('create-react-class');

var HighchartsReact = createReactClass({
  componentDidMount: function componentDidMount() {
    var p = this.props;
    var highcharts = p.highcharts || window.Highcharts;
    var constructorType = p.constructorType || 'chart'; // Create chart

    this.chart = highcharts[constructorType](this.container, Object.assign({}, p.options));
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var update = this.props.update; // Update if not specified or set to true

    return typeof update === 'undefined' || update;
  },
  componentDidUpdate: function componentDidUpdate() {
    this.chart.update(Object.assign({}, this.props.options), true, !(this.props.oneToOne === false));
  },
  componentWillReceiveProps: function componentWillReceiveProps() {
    this.chart.update(Object.assign({}, this.props.options), true, !(this.props.oneToOne === false));
  },
  componentWillUnmount: function componentWillUnmount() {
    // Destroy chart
    this.chart.destroy();
  },
  render: function render() {
    var self = this;
    var containerProps = this.props.containerProps || {}; // Add ref to div props

    containerProps.ref = function (container) {
      self.container = container;
    }; // Create container for our chart


    return React.createElement('div', containerProps);
  }
});
module.exports = HighchartsReact;